import axiosClient from "api/apiClient";
export const APIPostContactForm = (type: string, data: object) => {
    let url = "";
    if(type === "PNRAS") {
        url = "/email/pnras/grant";
    } else if(type === "PNRR") {
        url = "/email/pnras";
    }

    return axiosClient.post(url, data);
};